module.exports = __webpack_public_path__ + "img/referencia.56556101.svg";